// extracted by mini-css-extract-plugin
export var progressBar = "_it-0";
export var progressBarInner = "_it-1";